import { FC } from "react";
import { NsKey } from "enums/NsKey";
import { useDynamicTranslation } from "hooks/useDynamicTranslation";
import { ContractFunnel } from "../../types/interfaces";

interface FormulaCardBodyProps {
  contractFunnel: ContractFunnel;
  /** Opens the guarantee details panel, the same as the score of a comparable product does. */
  onSelectGuarantees: () => void;
}

/**
 * Guarantees of a fixed formula, in place of the score: all of them, as the same pills as the
 * mandatory guarantees of the header on the other branches. The line opens their details.
 */
export const FormulaCardBody: FC<FormulaCardBodyProps> = ({ contractFunnel, onSelectGuarantees }) => {
  const { t } = useDynamicTranslation([NsKey.Pricing]);

  return (
    <div className="flex flex-col gap-2 w-full">
      <p className="text-sm font-light">{t("PRICING.FORMULAS.INCLUDED_GUARANTEES")}</p>
      {/* One target for the whole line: the panel shows every guarantee, so they light up together. */}
      <button
        type="button"
        title={t("PRICING.FORMULAS.GUARANTEE_DETAILS")}
        onClick={onSelectGuarantees}
        className="group flex gap-1 flex-wrap text-left focus:outline-none"
      >
        {contractFunnel.guarantees.map(guarantee => (
          <span
            key={guarantee.id}
            className="text-xs text-lime-500 bg-white border border-lime-500 py-0 px-2 rounded-full transition-colors duration-150 group-hover:bg-lime-100 group-focus-visible:bg-lime-100"
          >
            {guarantee.shortName ? guarantee.shortName : guarantee.name}
          </span>
        ))}
      </button>
    </div>
  );
};
